export const languageMapping: { [key: string]: string } = {
  aa: 'Afar',
  aa_DJ: 'Afar aa_DJ',
  aa_ER: 'Afar aa_ER',
  aa_ET: 'Afar aa_ET',
  af: 'Afrikaans',
  af_NA: 'Afrikaans af_NA',
  af_ZA: 'Afrikaans af_ZA',
  agq: 'Aghem',
  agq_CM: 'Aghem agq_CM',
  ak: 'Akan',
  ak_GH: 'Akan ak_GH',
  sq: 'Albanian',
  sq_AL: 'Albanian sq_AL',
  sq_MK: 'Albanian sq_MK',
  gsw: 'Alsatian',
  gsw_FR: 'Alsatian gsw_FR',
  gsw_LI: 'Alsatian gsw_LI',
  gsw_CH: 'Alsatian gsw_CH',
  am: 'Amharic',
  am_ET: 'Amharic am_ET',
  ar: 'Arabic',
  ar_DZ: 'Arabic ar_DZ',
  ar_BH: 'Arabic ar_BH',
  ar_TD: 'Arabic ar_TD',
  ar_KM: 'Arabic ar_KM',
  ar_DJ: 'Arabic ar_DJ',
  ar_EG: 'Arabic ar_EG',
  ar_ER: 'Arabic ar_ER',
  ar_IQ: 'Arabic ar_IQ',
  ar_IL: 'Arabic ar_IL',
  ar_JO: 'Arabic ar_JO',
  ar_KW: 'Arabic ar_KW',
  ar_LB: 'Arabic ar_LB',
  ar_LY: 'Arabic ar_LY',
  ar_MR: 'Arabic ar_MR',
  ar_MA: 'Arabic ar_MA',
  ar_OM: 'Arabic ar_OM',
  ar_PS: 'Arabic ar_PS',
  ar_QA: 'Arabic ar_QA',
  ar_SA: 'Arabic ar_SA',
  ar_SO: 'Arabic ar_SO',
  ar_SS: 'Arabic ar_SS',
  ar_SD: 'Arabic ar_SD',
  ar_SY: 'Arabic ar_SY',
  ar_TN: 'Arabic ar_TN',
  ar_AE: 'Arabic ar_AE',
  ar_001: 'Arabic ar_001',
  ar_YE: 'Arabic ar_YE',
  hy: 'Armenian',
  hy_AM: 'Armenian hy_AM',
  as: 'Assamese',
  as_IN: 'Assamese as_IN',
  ast: 'Asturian',
  ast_ES: 'Asturian ast_ES',
  asa: 'Asu',
  asa_TZ: 'Asu asa_TZ',
  az_Cyrl: 'Azerbaijani (Cyrillic)',
  az_Cyrl_AZ: 'Azerbaijani (Cyrillic) az_Cyrl_AZ',
  az: 'Azerbaijani (Latin)',
  az_Latn: 'Azerbaijani (Latin)',
  az_Latn_AZ: 'Azerbaijani (Latin) az_Latn_AZ',
  ksf: 'Bafia',
  ksf_CM: 'Bafia ksf_CM',
  bm: 'Bamanankan',
  bm_Latn_ML: 'Bamanankan (Latin) bm_Latn_ML',
  bn: 'Bangla',
  bn_BD: 'Bangla bn_BD',
  bn_IN: 'Bangla bn_IN',
  bas: 'Basaa',
  bas_CM: 'Basaa bas_CM',
  ba: 'Bashkir',
  ba_RU: 'Bashkir ba_RU',
  eu: 'Basque',
  eu_ES: 'Basque eu_ES',
  be: 'Belarusian',
  be_BY: 'Belarusian be_BY',
  bem: 'Bemba',
  bem_ZM: 'Bemba bem_ZM',
  bez: 'Bena',
  bez_TZ: 'Bena bez_TZ',
  byn: 'Blin',
  byn_ER: 'Blin byn_ER',
  brx: 'Bodo',
  brx_IN: 'Bodo brx_IN',
  bs_Cyrl: 'Bosnian (Cyrillic)',
  bs_Cyrl_BA: 'Bosnian (Cyrillic) bs_Cyrl_BA',
  bs_Latn: 'Bosnian (Latin)',
  bs: 'Bosnian (Latin)',
  bs_Latn_BA: 'Bosnian (Latin) bs_Latn_BA',
  br: 'Breton',
  br_FR: 'Breton br_FR',
  bg: 'Bulgarian',
  bg_BG: 'Bulgarian bg_BG',
  my: 'Burmese',
  my_MM: 'Burmese my_MM',
  ca: 'Catalan',
  ca_AD: 'Catalan ca_AD',
  ca_FR: 'Catalan ca_FR',
  ca_IT: 'Catalan ca_IT',
  ca_ES: 'Catalan ca_ES',
  ceb: 'Cebuano',
  ceb_Latn: 'Cebuan (Latin)',
  ceb_Latn_PH: 'Cebuan (Latin) ceb_Latn_PH',
  tzm_Latn_: 'Central Atlas Tamazight (Latin) tzm_Latn_',
  ku: 'Central Kurdish',
  ku_Arab: 'Central Kurdish',
  ku_Arab_IQ: 'Central Kurdish ku_Arab_IQ',
  ccp: 'Chakma',
  ccp_Cakm: 'Chakma ccp_Cakm',
  ccp_Cakm_: 'Chakma ccp_Cakm_',
  cd_RU: 'Chechen cd_RU',
  chr: 'Cherokee',
  chr_Cher: 'Cherokee',
  chr_Cher_US: 'Cherokee chr_Cher_US',
  cgg: 'Chiga',
  cgg_UG: 'Chiga cgg_UG',
  zh_Hans: 'Mandarin',
  zh: 'Mandarin',
  zh_CN: 'Mandarin zh_CN',
  zh_SG: 'Mandarin zh_SG',
  zh_Hant: 'Chinese (Traditional)',
  zh_HK: 'Chinese (Traditional) zh_HK',
  zh_MO: 'Chinese (Traditional) zh_MO',
  zh_TW: 'Chinese (Traditional) zh_TW',
  cu_RU: 'Church Slavic cu_RU',
  swc: 'Congo Swahili',
  swc_CD: 'Congo Swahili swc_CD',
  kw: 'Cornish',
  kw_GB: 'Cornish kw_GB',
  co: 'Corsican',
  co_FR: 'Corsican co_FR',
  hr: 'Croatian',
  hr_HR: 'Croatian hr_HR',
  hr_BA: 'Croatian (Latin) hr_BA',
  cs: 'Czech',
  cs_CZ: 'Czech cs_CZ',
  da: 'Danish',
  da_DK: 'Danish da_DK',
  da_GL: 'Danish da_GL',
  prs: 'Dari',
  prs_AF: 'Dari prs_AF',
  dv: 'Divehi',
  dv_MV: 'Divehi dv_MV',
  dua: 'Duala',
  dua_CM: 'Duala dua_CM',
  nl: 'Dutch',
  nl_AW: 'Dutch nl_AW',
  nl_BE: 'Dutch nl_BE',
  nl_BQ: 'Dutch nl_BQ',
  nl_CW: 'Dutch nl_CW',
  nl_NL: 'Dutch nl_NL',
  nl_SX: 'Dutch nl_SX',
  nl_SR: 'Dutch nl_SR',
  dz: 'Dzongkha',
  dz_BT: 'Dzongkha dz_BT',
  ebu: 'Embu',
  ebu_KE: 'Embu ebu_KE',
  en: 'English',
  en_AS: 'English en_AS',
  en_AI: 'English en_AI',
  en_AG: 'English en_AG',
  en_AU: 'English en_AU',
  en_AT: 'English en_AT',
  en_BS: 'English en_BS',
  en_BB: 'English en_BB',
  en_BE: 'English en_BE',
  en_BZ: 'English en_BZ',
  en_BM: 'English en_BM',
  en_BW: 'English en_BW',
  en_IO: 'English en_IO',
  en_VG: 'English en_VG',
  en_BI: 'English en_BI',
  en_CM: 'English en_CM',
  en_CA: 'English en_CA',
  en_029: 'English en_029',
  en_KY: 'English en_KY',
  en_CX: 'English en_CX',
  en_CC: 'English en_CC',
  en_CK: 'English en_CK',
  en_CY: 'English en_CY',
  en_DK: 'English en_DK',
  en_DM: 'English en_DM',
  en_ER: 'English en_ER',
  en_150: 'English en_150',
  en_FK: 'English en_FK',
  en_FI: 'English en_FI',
  en_FJ: 'English en_FJ',
  en_GM: 'English en_GM',
  en_DE: 'English en_DE',
  en_GH: 'English en_GH',
  en_GI: 'English en_GI',
  en_GD: 'English en_GD',
  en_GU: 'English en_GU',
  en_GG: 'English en_GG',
  en_GY: 'English en_GY',
  en_HK: 'English en_HK',
  en_IN: 'English en_IN',
  en_IE: 'English en_IE',
  en_IM: 'English en_IM',
  en_IL: 'English en_IL',
  en_JM: 'English en_JM',
  en_JE: 'English en_JE',
  en_KE: 'English en_KE',
  en_KI: 'English en_KI',
  en_LS: 'English en_LS',
  en_LR: 'English en_LR',
  en_MO: 'English en_MO',
  en_MG: 'English en_MG',
  en_MW: 'English en_MW',
  en_MY: 'English en_MY',
  en_MT: 'English en_MT',
  en_MH: 'English en_MH',
  en_MU: 'English en_MU',
  en_FM: 'English en_FM',
  en_MS: 'English en_MS',
  en_NA: 'English en_NA',
  en_NR: 'English en_NR',
  en_NL: 'English en_NL',
  en_NZ: 'English en_NZ',
  en_NG: 'English en_NG',
  en_NU: 'English en_NU',
  en_NF: 'English en_NF',
  en_MP: 'English en_MP',
  en_PK: 'English en_PK',
  en_PW: 'English en_PW',
  en_PG: 'English en_PG',
  en_PN: 'English en_PN',
  en_PR: 'English en_PR',
  en_PH: 'English en_PH',
  en_RW: 'English en_RW',
  en_KN: 'English en_KN',
  en_LC: 'English en_LC',
  en_VC: 'English en_VC',
  en_WS: 'English en_WS',
  en_SC: 'English en_SC',
  en_SL: 'English en_SL',
  en_SG: 'English en_SG',
  en_SX: 'English en_SX',
  en_SI: 'English en_SI',
  en_SB: 'English en_SB',
  en_ZA: 'English en_ZA',
  en_SS: 'English en_SS',
  en_SH: 'English en_SH',
  en_SD: 'English en_SD',
  en_SZ: 'English en_SZ',
  en_SE: 'English en_SE',
  en_CH: 'English en_CH',
  en_TZ: 'English en_TZ',
  en_TK: 'English en_TK',
  en_TO: 'English en_TO',
  en_TT: 'English en_TT',
  en_TC: 'English en_TC',
  en_TV: 'English en_TV',
  en_UG: 'English en_UG',
  en_AE: 'English en_AE',
  en_GB: 'English en_GB',
  en_US: 'English en_US',
  en_UM: 'English en_UM',
  en_VI: 'English en_VI',
  en_VU: 'English en_VU',
  en_001: 'English en_001',
  en_ZM: 'English en_ZM',
  en_ZW: 'English en_ZW',
  eo: 'Esperanto',
  eo_001: 'Esperanto eo_001',
  et: 'Estonian',
  et_EE: 'Estonian et_EE',
  ee: 'Ewe',
  ee_GH: 'Ewe ee_GH',
  ee_TG: 'Ewe ee_TG',
  ewo: 'Ewondo',
  ewo_CM: 'Ewondo ewo_CM',
  fo: 'Faroese',
  fo_DK: 'Faroese fo_DK',
  fo_FO: 'Faroese fo_FO',
  fil: 'Filipino',
  fil_PH: 'Filipino fil_PH',
  fi: 'Finnish',
  fi_FI: 'Finnish fi_FI',
  fr: 'French',
  fr_DZ: 'French fr_DZ',
  fr_BE: 'French fr_BE',
  fr_BJ: 'French fr_BJ',
  fr_BF: 'French fr_BF',
  fr_BI: 'French fr_BI',
  fr_CM: 'French fr_CM',
  fr_CA: 'French fr_CA',
  fr_CF: 'French fr_CF',
  fr_TD: 'French fr_TD',
  fr_KM: 'French fr_KM',
  fr_CG: 'French fr_CG',
  fr_CD: 'French fr_CD',
  fr_CI: 'French fr_CI',
  fr_DJ: 'French fr_DJ',
  fr_GQ: 'French fr_GQ',
  fr_FR: 'French fr_FR',
  fr_GF: 'French fr_GF',
  fr_PF: 'French fr_PF',
  fr_GA: 'French fr_GA',
  fr_GP: 'French fr_GP',
  fr_GN: 'French fr_GN',
  fr_HT: 'French fr_HT',
  fr_LU: 'French fr_LU',
  fr_MG: 'French fr_MG',
  fr_ML: 'French fr_ML',
  fr_MQ: 'French fr_MQ',
  fr_MR: 'French fr_MR',
  fr_MU: 'French fr_MU',
  fr_YT: 'French fr_YT',
  fr_MA: 'French fr_MA',
  fr_NC: 'French fr_NC',
  fr_NE: 'French fr_NE',
  fr_MC: 'French fr_MC',
  fr_RE: 'French fr_RE',
  fr_RW: 'French fr_RW',
  fr_BL: 'French fr_BL',
  fr_MF: 'French fr_MF',
  fr_PM: 'French fr_PM',
  fr_SN: 'French fr_SN',
  fr_SC: 'French fr_SC',
  fr_CH: 'French fr_CH',
  fr_SY: 'French fr_SY',
  fr_TG: 'French fr_TG',
  fr_TN: 'French fr_TN',
  fr_VU: 'French fr_VU',
  fr_WF: 'French fr_WF',
  fy: 'Frisian',
  fy_NL: 'Frisian fy_NL',
  fur: 'Friulian',
  fur_IT: 'Friulian fur_IT',
  ff: 'Fulah',
  ff_Latn: 'Fulah (Latin)',
  ff_Latn_BF: 'Fulah (Latin) ff_Latn_BF',
  ff_CM: 'Fulah ff_CM',
  ff_Latn_CM: 'Fulah (Latin) ff_Latn_CM',
  ff_Latn_GM: 'Fulah (Latin) ff_Latn_GM',
  ff_Latn_GH: 'Fulah (Latin) ff_Latn_GH',
  ff_GN: 'Fulah ff_GN',
  ff_Latn_GN: 'Fulah (Latin) ff_Latn_GN',
  ff_Latn_GW: 'Fulah (Latin) ff_Latn_GW',
  ff_Latn_LR: 'Fulah (Latin) ff_Latn_LR',
  ff_MR: 'Fulah ff_MR',
  ff_Latn_MR: 'Fulah (Latin) ff_Latn_MR',
  ff_Latn_NE: 'Fulah (Latin) ff_Latn_NE',
  ff_NG: 'Fulah ff_NG',
  ff_Latn_NG: 'Fulah (Latin) ff_Latn_NG',
  ff_Latn_SN: 'Fulah ff_Latn_SN',
  ff_Latn_SL: 'Fulah (Latin) ff_Latn_SL',
  gl: 'Galician',
  gl_ES: 'Galician gl_ES',
  lg: 'Ganda',
  lg_UG: 'Ganda lg_UG',
  ka: 'Georgian',
  ka_GE: 'Georgian ka_GE',
  de: 'German',
  de_AT: 'German de_AT',
  de_BE: 'German de_BE',
  de_DE: 'German de_DE',
  de_IT: 'German de_IT',
  de_LI: 'German de_LI',
  de_LU: 'German de_LU',
  de_CH: 'German de_CH',
  el: 'Greek',
  el_CY: 'Greek el_CY',
  el_GR: 'Greek el_GR',
  kl: 'Greenlandic',
  kl_GL: 'Greenlandic kl_GL',
  gn: 'Guarani',
  gn_PY: 'Guarani gn_PY',
  gu: 'Gujarati',
  gu_IN: 'Gujarati gu_IN',
  guz: 'Gusii',
  guz_KE: 'Gusii guz_KE',
  ha: 'Hausa (Latin)',
  ha_Latn: 'Hausa (Latin)',
  ha_Latn_GH: 'Hausa (Latin) ha_Latn_GH',
  ha_Latn_NE: 'Hausa (Latin) ha_Latn_NE',
  ha_Latn_NG: 'Hausa (Latin) ha_Latn_NG',
  haw: 'Hawaiian',
  haw_US: 'Hawaiian haw_US',
  he: 'Hebrew',
  he_IL: 'Hebrew he_IL',
  hi: 'Hindi',
  hi_IN: 'Hindi hi_IN',
  hu: 'Hungarian',
  hu_HU: 'Hungarian hu_HU',
  is: 'Icelandic',
  is_IS: 'Icelandic is_IS',
  ig: 'Igbo',
  ig_NG: 'Igbo ig_NG',
  id: 'Indonesian',
  id_ID: 'Indonesian id_ID',
  ia: 'Interlingua',
  ia_FR: 'Interlingua ia_FR',
  ia_001: 'Interlingua ia_001',
  iu: 'Inuktitut (Latin)',
  iu_Latn: 'Inuktitut (Latin)',
  iu_Latn_CA: 'Inuktitut (Latin) iu_Latn_CA',
  iu_Cans: 'Inuktitut (Syllabics)',
  iu_Cans_CA: 'Inuktitut (Syllabics) iu_Cans_CA',
  ga: 'Irish',
  ga_IE: 'Irish ga_IE',
  it: 'Italian',
  it_IT: 'Italian it_IT',
  it_SM: 'Italian it_SM',
  it_CH: 'Italian it_CH',
  it_VA: 'Italian it_VA',
  ja: 'Japanese',
  ja_JP: 'Japanese ja_JP',
  jv: 'Javanese',
  jv_Latn: 'Javanese jv_Latn',
  jv_Latn_ID: 'Javanese jv_Latn_ID',
  dyo: 'Jola_Fonyi',
  dyo_SN: 'Jola_Fonyi dyo_SN',
  kea: 'Kabuverdianu',
  kea_CV: 'Kabuverdianu kea_CV',
  kab: 'Kabyle',
  kab_DZ: 'Kabyle kab_DZ',
  kkj: 'Kako',
  kkj_CM: 'Kako kkj_CM',
  kln: 'Kalenjin',
  kln_KE: 'Kalenjin kln_KE',
  kam: 'Kamba',
  kam_KE: 'Kamba kam_KE',
  kn: 'Kannada',
  kn_IN: 'Kannada kn_IN',
  ks: 'Kashmiri',
  ks_Arab: 'Kashmiri ks_Arab',
  ks_Arab_IN: 'Kashmiri ks_Arab_IN',
  kk: 'Kazakh',
  kk_KZ: 'Kazakh kk_KZ',
  km: 'Khmer',
  km_KH: 'Khmer km_KH',
  quc: "K'iche",
  quc_Latn_GT: "K'iche quc_Latn_GT",
  ki: 'Kikuyu',
  ki_KE: 'Kikuyu ki_KE',
  rw: 'Kinyarwanda',
  rw_RW: 'Kinyarwanda rw_RW',
  sw: 'Kiswahili',
  sw_KE: 'Kiswahili sw_KE',
  sw_TZ: 'Kiswahili sw_TZ',
  sw_UG: 'Kiswahili sw_UG',
  kok: 'Konkani',
  kok_IN: 'Konkani kok_IN',
  ko: 'Korean',
  ko_KR: 'Korean ko_KR',
  ko_KP: 'Korean ko_KP',
  khq: 'Koyra Chiini',
  khq_ML: 'Koyra Chiini khq_ML',
  ses: 'Koyraboro Senni',
  ses_ML: 'Koyraboro Senni ses_ML',
  nmg: 'Kwasio',
  nmg_CM: 'Kwasio nmg_CM',
  ky: 'Kyrgyz',
  ky_KG: 'Kyrgyz ky_KG',
  ku_Arab_IR: 'Kurdish ku_Arab_IR',
  lkt: 'Lakota',
  lkt_US: 'Lakota lkt_US',
  lag: 'Langi',
  lag_TZ: 'Langi lag_TZ',
  lo: 'Lao',
  lo_LA: 'Lao lo_LA',
  lv: 'Latvian',
  lv_LV: 'Latvian lv_LV',
  ln: 'Lingala',
  ln_AO: 'Lingala ln_AO',
  ln_CF: 'Lingala ln_CF',
  ln_CG: 'Lingala ln_CG',
  ln_CD: 'Lingala ln_CD',
  lt: 'Lithuanian',
  lt_LT: 'Lithuanian lt_LT',
  nds: 'Low German',
  nds_DE: 'Low German nds_DE',
  nds_NL: 'Low German nds_NL',
  dsb: 'Lower Sorbian',
  dsb_DE: 'Lower Sorbian dsb_DE',
  lu: 'Luba_Katanga',
  lu_CD: 'Luba_Katanga lu_CD',
  luo: 'Luo',
  luo_KE: 'Luo luo_KE',
  lb: 'Luxembourgish',
  lb_LU: 'Luxembourgish lb_LU',
  luy: 'Luyia',
  luy_KE: 'Luyia luy_KE',
  mk: 'Macedonian',
  mk_MK: 'Macedonian mk_MK',
  jmc: 'Machame',
  jmc_TZ: 'Machame jmc_TZ',
  mgh: 'Makhuwa_Meetto',
  mgh_MZ: 'Makhuwa_Meetto mgh_MZ',
  kde: 'Makonde',
  kde_TZ: 'Makonde kde_TZ',
  mg: 'Malagasy',
  mg_MG: 'Malagasy mg_MG',
  ms: 'Malay',
  ms_BN: 'Malay ms_BN',
  ms_MY: 'Malay ms_MY',
  ml: 'Malayalam',
  ml_IN: 'Malayalam ml_IN',
  mt: 'Maltese',
  mt_MT: 'Maltese mt_MT',
  gv: 'Manx',
  gv_IM: 'Manx gv_IM',
  mi: 'Maori',
  mi_NZ: 'Maori mi_NZ',
  arn: 'Mapudungun',
  arn_CL: 'Mapudungun arn_CL',
  mr: 'Marathi',
  mr_IN: 'Marathi mr_IN',
  mas: 'Masai',
  mas_KE: 'Masai mas_KE',
  mas_TZ: 'Masai mas_TZ',
  mzn_IR: 'Mazanderani mzn_IR',
  mer: 'Meru',
  mer_KE: 'Meru mer_KE',
  mgo: "Meta'",
  mgo_CM: "Meta' mgo_CM",
  moh: 'Mohawk',
  moh_CA: 'Mohawk moh_CA',
  mn: 'Mongolian (Cyrillic)',
  mn_Cyrl: 'Mongolian (Cyrillic)',
  mn_MN: 'Mongolian (Cyrillic) mn_MN',
  mn_Mong: 'Mongolian (Traditional Mongolian)',
  mn_Mong_CN: 'Mongolian (Traditional Mongolian) mn_Mong_CN',
  mn_Mong_MN: 'Mongolian (Traditional Mongolian) mn_Mong_MN',
  mfe: 'Morisyen',
  mfe_MU: 'Morisyen mfe_MU',
  mua: 'Mundang',
  mua_CM: 'Mundang mua_CM',
  nqo: "N'ko",
  nqo_GN: "N'ko nqo_GN",
  naq: 'Nama',
  naq_NA: 'Nama naq_NA',
  ne: 'Nepali',
  ne_IN: 'Nepali ne_IN',
  ne_NP: 'Nepali ne_NP',
  nnh: 'Ngiemboon',
  nnh_CM: 'Ngiemboon nnh_CM',
  jgo: 'Ngomba',
  jgo_CM: 'Ngomba jgo_CM',
  lrc_IQ: 'Northern Luri lrc_IQ',
  lrc_IR: 'Northern Luri lrc_IR',
  nd: 'North Ndebele',
  nd_ZW: 'North Ndebele nd_ZW',
  no: 'Norwegian (Bokmal)',
  nb: 'Norwegian (Bokmal)',
  nb_NO: 'Norwegian (Bokmal) nb_NO',
  nn: 'Norwegian (Nynorsk)',
  nn_NO: 'Norwegian (Nynorsk) nn_NO',
  nb_SJ: 'Norwegian Bokmål nb_SJ',
  nus: 'Nuer',
  nus_SD: 'Nuer nus_SD',
  nus_SS: 'Nuer nus_SS',
  nyn: 'Nyankole',
  nyn_UG: 'Nyankole nyn_UG',
  oc: 'Occitan',
  oc_FR: 'Occitan oc_FR',
  or: 'Odia',
  or_IN: 'Odia or_IN',
  om: 'Oromo',
  om_ET: 'Oromo om_ET',
  om_KE: 'Oromo om_KE',
  os: 'Ossetian',
  os_GE: 'Ossetian os_GE',
  os_RU: 'Ossetian os_RU',
  ps: 'Pashto',
  ps_AF: 'Pashto ps_AF',
  ps_PK: 'Pashto ps_PK',
  fa: 'Persian',
  fa_AF: 'Persian fa_AF',
  fa_IR: 'Persian fa_IR',
  pl: 'Polish',
  pl_PL: 'Polish pl_PL',
  pt: 'Portuguese',
  pt_AO: 'Portuguese pt_AO',
  pt_BR: 'Portuguese pt_BR',
  pt_CV: 'Portuguese pt_CV',
  pt_GQ: 'Portuguese pt_GQ',
  pt_GW: 'Portuguese pt_GW',
  pt_LU: 'Portuguese pt_LU',
  pt_MO: 'Portuguese pt_MO',
  pt_MZ: 'Portuguese pt_MZ',
  pt_PT: 'Portuguese pt_PT',
  pt_ST: 'Portuguese pt_ST',
  pt_CH: 'Portuguese pt_CH',
  pt_TL: 'Portuguese pt_TL',
  prg_001: 'Prussian',
  qps_ploca: 'Pseudo Language qps_ploca',
  qps_ploc: 'Pseudo Language qps_ploc',
  qps_plocm: 'Pseudo Language qps_plocm',
  pa: 'Punjabi',
  pa_Arab: 'Punjabi',
  pa_IN: 'Punjabi pa_IN',
  pa_Arab_PK: 'Punjabi pa_Arab_PK',
  quz: 'Quechua',
  quz_BO: 'Quechua quz_BO',
  quz_EC: 'Quechua quz_EC',
  quz_PE: 'Quechua quz_PE',
  ksh: 'Ripuarian',
  ksh_DE: 'Ripuarian ksh_DE',
  ro: 'Romanian',
  ro_MD: 'Romanian ro_MD',
  ro_RO: 'Romanian ro_RO',
  rm: 'Romansh',
  rm_CH: 'Romansh rm_CH',
  rof: 'Rombo',
  rof_TZ: 'Rombo rof_TZ',
  rn: 'Rundi',
  rn_BI: 'Rundi rn_BI',
  ru: 'Russian',
  ru_BY: 'Russian ru_BY',
  ru_KZ: 'Russian ru_KZ',
  ru_KG: 'Russian ru_KG',
  ru_MD: 'Russian ru_MD',
  ru_RU: 'Russian ru_RU',
  ru_UA: 'Russian ru_UA',
  rwk: 'Rwa',
  rwk_TZ: 'Rwa rwk_TZ',
  ssy: 'Saho',
  ssy_ER: 'Saho ssy_ER',
  sah: 'Sakha',
  sah_RU: 'Sakha sah_RU',
  saq: 'Samburu',
  saq_KE: 'Samburu saq_KE',
  smn: 'Sami (Inari)',
  smn_FI: 'Sami (Inari) smn_FI',
  smj: 'Sami (Lule)',
  smj_NO: 'Sami (Lule) smj_NO',
  smj_SE: 'Sami (Lule) smj_SE',
  se: 'Sami (Northern)',
  se_FI: 'Sami (Northern) se_FI',
  se_NO: 'Sami (Northern) se_NO',
  se_SE: 'Sami (Northern) se_SE',
  sms: 'Sami (Skolt)',
  sms_FI: 'Sami (Skolt) sms_FI',
  sma: 'Sami (Southern)',
  sma_NO: 'Sami (Southern) sma_NO',
  sma_SE: 'Sami (Southern) sma_SE',
  sg: 'Sango',
  sg_CF: 'Sango sg_CF',
  sbp: 'Sangu',
  sbp_TZ: 'Sangu sbp_TZ',
  sa: 'Sanskrit',
  sa_IN: 'Sanskrit sa_IN',
  gd: 'Scottish Gaelic',
  gd_GB: 'Scottish Gaelic gd_GB',
  seh: 'Sena',
  seh_MZ: 'Sena seh_MZ',
  sr_Cyrl: 'Serbian (Cyrillic)',
  sr_Cyrl_BA: 'Serbian (Cyrillic) sr_Cyrl_BA',
  sr_Cyrl_ME: 'Serbian (Cyrillic) sr_Cyrl_ME',
  sr_Cyrl_RS: 'Serbian (Cyrillic) sr_Cyrl_RS',
  sr_Cyrl_CS: 'Serbian (Cyrillic) sr_Cyrl_CS',
  sr_Latn: 'Serbian (Latin)',
  sr: 'Serbian (Latin)',
  sr_Latn_BA: 'Serbian (Latin) sr_Latn_BA',
  sr_Latn_ME: 'Serbian (Latin) sr_Latn_ME',
  sr_Latn_RS: 'Serbian (Latin) sr_Latn_RS',
  sr_Latn_CS: 'Serbian (Latin) sr_Latn_CS',
  nso: 'Sesotho sa Leboa',
  nso_ZA: 'Sesotho sa Leboa nso_ZA',
  tn: 'Setswana',
  tn_BW: 'Setswana tn_BW',
  tn_ZA: 'Setswana tn_ZA',
  ksb: 'Shambala',
  ksb_TZ: 'Shambala ksb_TZ',
  sn: 'Shona',
  sn_Latn: 'Shona sn_Latn',
  sn_Latn_ZW: 'Shona sn_Latn_ZW',
  sd: 'Sindhi',
  sd_Arab: 'Sindhi',
  sd_Arab_PK: 'Sindhi sd_Arab_PK',
  si: 'Sinhala',
  si_LK: 'Sinhala si_LK',
  sk: 'Slovak',
  sk_SK: 'Slovak sk_SK',
  sl: 'Slovenian',
  sl_SI: 'Slovenian sl_SI',
  xog: 'Soga',
  xog_UG: 'Soga xog_UG',
  so: 'Somali',
  so_DJ: 'Somali so_DJ',
  so_ET: 'Somali so_ET',
  so_KE: 'Somali so_KE',
  so_SO: 'Somali so_SO',
  st: 'Sotho',
  st_ZA: 'Sotho st_ZA',
  nr: 'South Ndebele',
  nr_ZA: 'South Ndebele nr_ZA',
  st_LS: 'Southern Sotho st_LS',
  es: 'Spanish',
  es_AR: 'Spanish es_AR',
  es_BZ: 'Spanish es_BZ',
  es_VE: 'Spanish es_VE',
  es_BO: 'Spanish es_BO',
  es_BR: 'Spanish es_BR',
  es_CL: 'Spanish es_CL',
  es_CO: 'Spanish es_CO',
  es_CR: 'Spanish es_CR',
  es_CU: 'Spanish es_CU',
  es_DO: 'Spanish es_DO',
  es_EC: 'Spanish es_EC',
  es_SV: 'Spanish es_SV',
  es_GQ: 'Spanish es_GQ',
  es_GT: 'Spanish es_GT',
  es_HN: 'Spanish es_HN',
  es_419: 'Spanish es_419',
  es_MX: 'Spanish es_MX',
  es_NI: 'Spanish es_NI',
  es_PA: 'Spanish es_PA',
  es_PY: 'Spanish es_PY',
  es_PE: 'Spanish es_PE',
  es_PH: 'Spanish es_PH',
  es_PR: 'Spanish es_PR',
  es_ES_tradnl: 'Spanish es_ES_tradnl',
  es_ES: 'Spanish es_ES',
  es_US: 'Spanish es_US',
  es_UY: 'Spanish es_UY',
  zgh: 'Standard Moroccan Tamazight',
  zgh_Tfng_MA: 'Standard Moroccan Tamazight zgh_Tfng_MA',
  zgh_Tfng: 'Standard Moroccan Tamazight zgh_Tfng',
  ss: 'Swati',
  ss_ZA: 'Swati ss_ZA',
  ss_SZ: 'Swati ss_SZ',
  sv: 'Swedish',
  sv_AX: 'Swedish sv_AX',
  sv_FI: 'Swedish sv_FI',
  sv_SE: 'Swedish sv_SE',
  syr: 'Syriac',
  syr_SY: 'Syriac syr_SY',
  shi: 'Tachelhit',
  shi_Tfng: 'Tachelhit shi_Tfng',
  shi_Tfng_MA: 'Tachelhit shi_Tfng_MA',
  shi_Latn: 'Tachelhit (Latin)',
  shi_Latn_MA: 'Tachelhit (Latin) shi_Latn_MA',
  dav: 'Taita',
  dav_KE: 'Taita dav_KE',
  tg: 'Tajik (Cyrillic)',
  tg_Cyrl: 'Tajik (Cyrillic)',
  tg_Cyrl_TJ: 'Tajik (Cyrillic) tg_Cyrl_TJ',
  tzm: 'Tamazight (Latin)',
  tzm_Latn: 'Tamazight (Latin)',
  tzm_Latn_DZ: 'Tamazight (Latin) tzm_Latn_DZ',
  ta: 'Tamil',
  ta_IN: 'Tamil ta_IN',
  ta_MY: 'Tamil ta_MY',
  ta_SG: 'Tamil ta_SG',
  ta_LK: 'Tamil ta_LK',
  twq: 'Tasawaq',
  twq_NE: 'Tasawaq twq_NE',
  tt: 'Tatar',
  tt_RU: 'Tatar tt_RU',
  te: 'Telugu',
  te_IN: 'Telugu te_IN',
  teo: 'Teso',
  teo_KE: 'Teso teo_KE',
  teo_UG: 'Teso teo_UG',
  th: 'Thai',
  th_TH: 'Thai th_TH',
  bo: 'Tibetan',
  bo_IN: 'Tibetan bo_IN',
  bo_CN: 'Tibetan bo_CN',
  tig: 'Tigre',
  tig_ER: 'Tigre tig_ER',
  ti: 'Tigrinya',
  ti_ER: 'Tigrinya ti_ER',
  ti_ET: 'Tigrinya ti_ET',
  to: 'Tongan',
  to_TO: 'Tongan to_TO',
  ts: 'Tsonga',
  ts_ZA: 'Tsonga ts_ZA',
  tr: 'Turkish',
  tr_CY: 'Turkish tr_CY',
  tr_TR: 'Turkish tr_TR',
  tk: 'Turkmen',
  tk_TM: 'Turkmen tk_TM',
  uk: 'Ukrainian',
  uk_UA: 'Ukrainian uk_UA',
  hsb: 'Upper Sorbian',
  hsb_DE: 'Upper Sorbian hsb_DE',
  ur: 'Urdu',
  ur_IN: 'Urdu ur_IN',
  ur_PK: 'Urdu ur_PK',
  ug: 'Uyghur',
  ug_CN: 'Uyghur ug_CN',
  uz_Arab: 'Uzbek uz_Arab',
  uz_Arab_AF: 'Uzbek uz_Arab_AF',
  uz_Cyrl: 'Uzbek (Cyrillic)',
  uz_Cyrl_UZ: 'Uzbek (Cyrillic) uz_Cyrl_UZ',
  uz: 'Uzbek (Latin)',
  uz_Latn: 'Uzbek (Latin)',
  uz_Latn_UZ: 'Uzbek (Latin) uz_Latn_UZ',
  vai: 'Vai',
  vai_Vaii: 'Vai',
  vai_Vaii_LR: 'Vai vai_Vaii_LR',
  vai_Latn_LR: 'Vai (Latin) vai_Latn_LR',
  vai_Latn: 'Vai (Latin)',
  ca_ES_: 'Valencian ca_ES_',
  ve: 'Venda',
  ve_ZA: 'Venda ve_ZA',
  vi: 'Vietnamese',
  vi_VN: 'Vietnamese vi_VN',
  vo: 'Volapük',
  vo_001: 'Volapük vo_001',
  vun: 'Vunjo',
  vun_TZ: 'Vunjo vun_TZ',
  wae: 'Walser',
  wae_CH: 'Walser wae_CH',
  cy: 'Welsh',
  cy_GB: 'Welsh cy_GB',
  wal: 'Wolaytta',
  wal_ET: 'Wolaytta wal_ET',
  wo: 'Wolof',
  wo_SN: 'Wolof wo_SN',
  xh: 'Xhosa',
  xh_ZA: 'Xhosa xh_ZA',
  yav: 'Yangben',
  yav_CM: 'Yangben yav_CM',
  ii: 'Yi',
  ii_CN: 'Yi ii_CN',
  yo: 'Yoruba',
  yo_BJ: 'Yoruba yo_BJ',
  yo_NG: 'Yoruba yo_NG',
  dje: 'Zarma',
  dje_NE: 'Zarma dje_NE',
  zu: 'Zulu',
  zu_ZA: 'Zulu zu_ZA',
};

export const languageMappingForTranslation: { [key: string]: string } = {
  af: 'Afrikaans',
  sq: 'Albanian',
  am: 'Amharic',
  ar: 'Arabic',
  hy: 'Armenian',
  as: 'Assamese',
  ay: 'Aymara',
  az: 'Azerbaijani',
  bm: 'Bambara',
  eu: 'Basque',
  be: 'Belarusian',
  bn: 'Bengali',
  bho: 'Bhojpuri',
  bs: 'Bosnian',
  bg: 'Bulgarian',
  ca: 'Catalan',
  ceb: 'Cebuano',
  ny: 'Chichewa',
  zh: 'Mandarin',
  'zh-TW': 'Chinese (Traditional)',
  co: 'Corsican',
  hr: 'Croatian',
  cs: 'Czech',
  da: 'Danish',
  dv: 'Divehi',
  doi: 'Dogri',
  nl: 'Dutch',
  en: 'English',
  eo: 'Esperanto',
  et: 'Estonian',
  ee: 'Ewe',
  tl: 'Filipino',
  fi: 'Finnish',
  fr: 'French',
  fy: 'Frisian',
  gl: 'Galician',
  lg: 'Ganda',
  ka: 'Georgian',
  de: 'German',
  el: 'Greek',
  gn: 'Guarani',
  gu: 'Gujarati',
  ht: 'Haitian Creole',
  ha: 'Hausa',
  haw: 'Hawaiian',
  iw: 'Hebrew',
  hi: 'Hindi',
  hmn: 'Hmong',
  hu: 'Hungarian',
  is: 'Icelandic',
  ig: 'Igbo',
  ilo: 'Iloko',
  id: 'Indonesian',
  ga: 'Irish Gaelic',
  it: 'Italian',
  ja: 'Japanese',
  jw: 'Javanese',
  kn: 'Kannada',
  kk: 'Kazakh',
  km: 'Khmer',
  rw: 'Kinyarwanda',
  gom: 'Konkani',
  ko: 'Korean',
  kri: 'Krio',
  ku: 'Kurdish (Kurmanji)',
  ckb: 'Kurdish (Sorani)',
  ky: 'Kyrgyz',
  lo: 'Lao',
  la: 'Latin',
  lv: 'Latvian',
  ln: 'Lingala',
  lt: 'Lithuanian',
  lb: 'Luxembourgish',
  mk: 'Macedonian',
  mai: 'Maithili',
  mg: 'Malagasy',
  ms: 'Malay',
  ml: 'Malayalam',
  mt: 'Maltese',
  mi: 'Maori',
  mr: 'Marathi',
  'mni-Mtei': 'Meiteilon (Manipuri)',
  lus: 'Mizo',
  mn: 'Mongolian',
  my: 'Myanmar (Burmese)',
  ne: 'Nepali',
  nso: 'Northern Sotho',
  no: 'Norwegian',
  or: 'Odia (Oriya)',
  om: 'Oromo',
  ps: 'Pashto',
  fa: 'Persian',
  pl: 'Polish',
  pt: 'Portuguese',
  pa: 'Punjabi',
  qu: 'Quechua',
  ro: 'Romanian',
  ru: 'Russian',
  sm: 'Samoan',
  sa: 'Sanskrit',
  gd: 'Scots Gaelic',
  sr: 'Serbian',
  st: 'Sesotho',
  sn: 'Shona',
  sd: 'Sindhi',
  si: 'Sinhala',
  sk: 'Slovak',
  sl: 'Slovenian',
  so: 'Somali',
  es: 'Spanish',
  su: 'Sundanese',
  sw: 'Swahili',
  sv: 'Swedish',
  tg: 'Tajik',
  ta: 'Tamil',
  tt: 'Tatar',
  te: 'Telugu',
  th: 'Thai',
  ti: 'Tigrinya',
  ts: 'Tsonga',
  tr: 'Turkish',
  tk: 'Turkmen',
  ak: 'Twi',
  uk: 'Ukrainian',
  ur: 'Urdu',
  ug: 'Uyghur',
  uz: 'Uzbek',
  vi: 'Vietnamese',
  cy: 'Welsh',
  xh: 'Xhosa',
  yi: 'Yiddish',
  yo: 'Yoruba',
  zu: 'Zulu',
  he: 'Hebrew',
  jv: 'Javanese',
};
